import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {Grid,Typography,TextField} from "@material-ui/core";
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
    root: {
      backgroundColor: theme.palette.background.paper,
      padding:5,
      marginBottom:10,
      borderRadius:5,
      margin:30
    },
    rootButton:{
      margin:10,
    }
  }));

export const BuscadorCuil = (props) => {
    const classes = useStyles();

  return (
      <Grid container direction="row" alignItems="center" justify="center"  spacing={2}>
            <Grid >
            <Typography
                component="h1"
                variant="h5"
                style={{
                marginRight: 10,
                align: "center",
                color: "#FAFAFA",
                justifyContent: "center",
                }}
            >
                Cuil
            </Typography>
            </Grid>
            <Grid className={classes.root}>
                <TextField
                    variant="outlined"
                    label="Cuil"
                    name="cuilIngresado"
                    onChange={props.onChangeCuil}
                    autoComplete={'off'}
                    value={props.cuil}
                    onKeyDown={props.onKeyDown}
                    onInput = {(e) =>{
                        e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,11)
                    }}
                />
            </Grid>
           
            <Snackbar open={props.open} autoHideDuration={6000} onClose={props.handleClose}>
              <Alert onClose={props.handleClose} severity="error">
                El cuil es Invalido. Por favor verificar!
              </Alert>
            </Snackbar>
    </Grid>
  );
};
